export default (context:any, payload:any) => {
    const moduleId = context.getters.moduleId;

    const setAttribute = payload.oneLni.storeUtils.setAttribute;
    setAttribute(context, `${moduleId}_notification-collapse`, 'visible', true);

    const timeout = context.rootState[moduleId].notificationTimeout;
    setTimeout(() => {
        if (context.rootState[`${moduleId}_notification-collapse`]) {
            setAttribute(context, `${moduleId}_notification-collapse`, 'visible', false);
        }
    }, timeout);
};